export default __webpack_public_path__ + "static/media/fish.70a11e10.svg";